import { createFileRoute, Outlet, Link, useLocation } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

/**
 * @graph-node {Page}
 * @graph-stack mall
 * @graph-domain Operations
 * @graph-business マスタデータレイアウト。brands/categories/brand-linesタブナビゲーションとOutletを提供
 * @graph-connects none
 */
export const Route = createFileRoute('/master')({
  component: MasterLayout,
});

/** @graph-connects none */
function MasterLayout() {
  const { t } = useTranslation();
  const location = useLocation();

  const tabs = [
    { to: '/master/brands', label: t('master.brands') },
    { to: '/master/categories', label: t('master.categories') },
    { to: '/master/brand-lines', label: t('master.brandLines') },
  ];

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-[var(--color-text-primary)]">{t('master.title')}</h1>
        <p className="mt-1 text-sm text-[var(--color-text-secondary)]">{t('master.description')}</p>
      </div>

      {/* タブナビゲーション */}
      <div className="flex gap-1 p-1 rounded-lg bg-[var(--color-bg-elevated)] border border-[var(--color-border)]">
        {tabs.map((tab) => (
          <Link
            key={tab.to}
            to={tab.to}
            className={`
              flex-1 px-4 py-2 text-sm font-medium text-center rounded-md
              transition-all duration-[var(--transition-fast)]
              ${
                location.pathname === tab.to
                  ? 'bg-[var(--color-accent-muted)] text-[var(--color-accent-primary)] border border-[var(--color-accent-primary)]/20'
                  : 'text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] hover:bg-[var(--color-bg-hover)]'
              }
            `}
          >
            {tab.label}
          </Link>
        ))}
      </div>

      <Outlet />
    </div>
  );
}
